// src/contexts/ResultsContext.js
import React, { createContext, useState } from "react";
// import autoResultsLOCAL from "./data/simulation_detail_auto.json";
// import fireResultsLOCAL from "./data/simulation_detail_fire.json";
import autoResultsLOCAL from "./data/simulation_detail_auto_final.json";
import fireResultsLOCAL from "./data/simulation_detail_fire_final.json";

// import fireResultsLOCAL from "./data/MOCK_fire_claim_output.json";

import { useSortFilter } from "./SortFilterContext";

export const ResultsContext = createContext();

const ResultsProvider = ({ children }) => {

  const [autoResults, setAutoResults] = useState(autoResultsLOCAL);
  const [filteredAutoResults, setFilteredAutoResults] = useState(autoResultsLOCAL);


  const [fireResults, setFireResults] = useState(fireResultsLOCAL);
  const [filteredFireResults, setFilteredFireResults] = useState(fireResultsLOCAL);


  const { setFilters } = useSortFilter();
  // const { modelSelected } = React.useContext(ModelContext);

  const resetResults = () => {
      setAutoResults(autoResultsLOCAL);
      setFireResults(fireResultsLOCAL);
      setFilteredAutoResults(autoResultsLOCAL);
      setFilteredFireResults(fireResultsLOCAL);
    
    setFilters({
      valid_docs_only: false,
      pd_tasks_only: false,
      sha_excluded_only: false,
    });
  };

  console.log(autoResults);

  return (
    <ResultsContext.Provider
      value={{
        autoResults,
        filteredAutoResults,
        setFilteredAutoResults,
       
        fireResults,
        filteredFireResults,
        setFilteredFireResults,
       
        resetResults,

        numAutoClaims: autoResults?.length || 0,
        numFireClaims: fireResults?.length || 0,
      }}
    >
      {children}`{" "}
    </ResultsContext.Provider>
  );
};

export default ResultsProvider;
